// extracted by mini-css-extract-plugin
export default {"dropbtn":"navbarSignUp_dropbtn__y+kz-","dropdown":"navbarSignUp_dropdown__4I1HW","dropdownContent":"navbarSignUp_dropdownContent__RHXJh"};